import React from 'react';
import { useNavigate } from 'react-router-dom';

const CUSTOMER_SUPPORT = [
    { label: 'Contact Us', path: '/contact' },
    { label: 'Help Center', path: '/contact' },
    { label: 'About Us', path: '/' },
    { label: 'Careers', path: '/' },
];

const POLICY = [
    { label: 'Shipping & Returns', path: '/contact' },
    { label: 'Terms & Conditions', path: '/contact' },
    { label: 'Payment Methods', path: '/contact' },
    { label: 'FAQ', path: '/contact' },
];

// const PAYMENT_METHODS = [
//     { src: '/arkab/Visa.png', alt: 'Visa' },
//     { src: '/arkab/brand-mastercard-403x.png', alt: 'Mastercard' },
//     { src: '/arkab/brand-amex-403x.png', alt: 'Amex' },
//     { src: '/arkab/brand-chinaunionpay-403x.png', alt: 'UnionPay' },
//     { src: '/arkab/brand-jcb-403x.png', alt: 'JCB' },
// ];

const linkStyle: React.CSSProperties = {
    cursor: 'pointer',
    fontSize: '0.9rem',
    color: '#5a5a5a',
    textDecoration: 'none',
    transition: 'color 0.25s ease, transform 0.2s ease',
    display: 'block',
    fontWeight: 500,
};

const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer style={{ backgroundColor: '#fafafa', color: '#000000', borderTop: '1px solid #e5e7eb' }}>

            {/* Main footer columns — Customer Support | Policy */}
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem 3rem' }}>
                <div style={{ display: 'flex', gap: '3rem', flexWrap: 'wrap' }}>

                    {/* Customer Support */}
                    <div style={{ flex: '1 1 240px' }}>
                        <h6 style={{
                            fontFamily: 'var(--arkab-font-heading)', fontWeight: 700,
                            fontSize: '1.05rem', marginBottom: '1.6rem', color: '#0a0a0a',
                            letterSpacing: '-0.01em',
                        }}>
                            Customer Support
                        </h6>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>
                            {CUSTOMER_SUPPORT.map(item => (
                                <li key={item.label}>
                                    <span
                                        onClick={() => navigate(item.path)}
                                        style={linkStyle}
                                        onMouseEnter={e => { 
                                            (e.currentTarget as HTMLElement).style.color = '#0a0a0a';
                                            (e.currentTarget as HTMLElement).style.transform = 'translateX(2px)';
                                        }}
                                        onMouseLeave={e => { 
                                            (e.currentTarget as HTMLElement).style.color = '#5a5a5a';
                                            (e.currentTarget as HTMLElement).style.transform = 'translateX(0)';
                                        }}
                                    >
                                        {item.label}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Policy */}
                    <div style={{ flex: '1 1 240px' }}>
                        <h6 style={{
                            fontFamily: 'var(--arkab-font-heading)', fontWeight: 700,
                            fontSize: '1.05rem', marginBottom: '1.6rem', color: '#0a0a0a',
                            letterSpacing: '-0.01em',
                        }}>
                            Policy
                        </h6>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>
                            {POLICY.map(item => (
                                <li key={item.label}>
                                    <span
                                        onClick={() => navigate(item.path)}
                                        style={linkStyle}
                                        onMouseEnter={e => { 
                                            (e.currentTarget as HTMLElement).style.color = '#0a0a0a';
                                            (e.currentTarget as HTMLElement).style.transform = 'translateX(2px)';
                                        }}
                                        onMouseLeave={e => { 
                                            (e.currentTarget as HTMLElement).style.color = '#5a5a5a';
                                            (e.currentTarget as HTMLElement).style.transform = 'translateX(0)';
                                        }}
                                    >
                                        {item.label}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </div>

            {/* Payment methods strip (hidden until payment options are finalized)
            <div style={{ borderTop: '1px solid #e5e7eb', padding: '2rem 1.5rem', backgroundColor: '#ffffff' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
                    <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '1.25rem', letterSpacing: '0.02em', fontWeight: 500 }}>
                        We accept the following paying methods
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
                        {PAYMENT_METHODS.map(pm => (
                            <img
                                key={pm.alt}
                                src={pm.src}
                                alt={pm.alt}
                                style={{ height: '32px', objectFit: 'contain', opacity: 0.85, transition: 'opacity 0.2s ease' }}
                                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.opacity = '1'; }}
                                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.opacity = '0.85'; }}
                            />
                        ))}
                    </div>
                </div>
            </div>
            */}

            {/* Copyright bar */}
            <div style={{
                backgroundColor: '#1a1a1a', color: 'rgba(255,255,255,0.85)', textAlign: 'center',
                padding: '1.1rem 1rem', fontSize: '0.8rem', letterSpacing: '0.03em', fontWeight: 500,
            }}>
                © {new Date().getFullYear()} Arkab Collections. All rights reserved.
            </div>

        </footer>
    );
};

export default Footer;
